import { GetterTree } from "vuex";
import { RootState } from "..";
import { State } from "./state";
import RecoveryAgent from "@/models/recoveryAgent.model";

export interface Getters {
  agents: RecoveryAgent[];
}

export const getters: GetterTree<State, RootState> = {
  agents(state): RecoveryAgent[] {
    return state.agents ?? [];
  }
};
